import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

const SmsRemindersToggle = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>SMS-herinneringen</h2>
            <p>
                Zet aan om bij taken een SMS-herinnering te kunnen kiezen. Let op: voor iedere verstuurde SMS worden kosten in rekening gebracht. Een SMS wordt alleen verstuurd als de ontvanger hiervoor toestemming heeft gegeven.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>SMS-herinneringen inschakelen</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"SmsRemindersEnabled"}
                        collection={"CompagnyMeta"}
                        value={comp.SmsRemindersEnabled}
                    />
                </div>
            ))}
        </div>
    );
};

export default SmsRemindersToggle;
